import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";

import { makeStyles } from "@mui/styles";
import React from "react";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1),
  },
  input: {
    height: "40px",
  },
}));

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
    />
  );
});

NumberFormatCustom.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

const CurrencyInput = ({
  name,
  label,
  control,
  defaultValue,
  helperText,
  disabled,
  ...props
}) => {
  const labelId = `${name}-label`;
  const classes = useStyles();

  return (
    <Controller
      render={({ field: { onChange, onBlur, value } }) => (
        <FormControl
          fullWidth
          className={classes.root}
          disabled={disabled}
          sx={{ m: 1 }}
          {...props}
        >
          <InputLabel id={labelId}>{label}</InputLabel>
          <OutlinedInput
            className={classes.input}
            label={label}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            inputComponent={NumberFormatCustom}
            startAdornment={
              <InputAdornment position="start">{props.symbol}</InputAdornment>
            }
            placeholder={"0"}
          />
          <FormHelperText sx={{ m: 0 }} error={props.error}>
            {helperText}
          </FormHelperText>
        </FormControl>
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  );
};

export default CurrencyInput;
